import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useInView } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { useIsMobileDimension } from '@beef/ui-kit';
var TIMER_TIMEOUT = 5000;
export var useSliderTimer = function useSliderTimer(_ref) {
  var slidesCount = _ref.slidesCount,
    swiperInstance = _ref.swiperInstance,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? true : _ref$loop,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? true : _ref$autoplay;
  var isMobile = useIsMobileDimension();
  var timer = useRef();
  var ref = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    isActiveIndex = _useState2[0],
    setIsActiveIndex = _useState2[1];
  var inView = useInView(ref);
  var observer = useRef(null);
  useEffect(function () {
    var _Array$from, _ref$current2;
    var handleIntersection = function handleIntersection(entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var _ref$current$children, _ref$current;
          var index = Array.from((_ref$current$children = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.children) !== null && _ref$current$children !== void 0 ? _ref$current$children : []).indexOf(entry.target);
          setIsActiveIndex(index);
        }
      });
    };
    observer.current = new IntersectionObserver(handleIntersection, {
      root: ref.current,
      threshold: 0.5 // настроить порог видимости
    });

    // const elements = ref.current?.children(`.${cardClassName}`);
    (_Array$from = Array.from(((_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.children) || [])) === null || _Array$from === void 0 ? void 0 : _Array$from.forEach(function (el) {
      var _observer$current;
      return (_observer$current = observer.current) === null || _observer$current === void 0 ? void 0 : _observer$current.observe(el);
    });
    return function () {
      var _observer$current2;
      (_observer$current2 = observer.current) === null || _observer$current2 === void 0 ? void 0 : _observer$current2.disconnect();
    };
  }, [ref]);
  useEffect(function () {
    // отменяем запуск автоплея, пока не увидим блок во вьюпорте
    if (!inView || isMobile || !autoplay) {
      return function () {};
    }
    timer.current = setTimeout(function () {
      if (loop) {
        setIsActiveIndex(function (currentIndex) {
          var nextSlideIndex = currentIndex + 1;
          return nextSlideIndex === slidesCount ? 0 : nextSlideIndex;
        });
        return;
      }
      setIsActiveIndex(function (currentIndex) {
        var nextSlideIndex = currentIndex + 1;
        return nextSlideIndex === slidesCount ? currentIndex : nextSlideIndex;
      });
    }, TIMER_TIMEOUT);
    return function () {
      return timer.current && clearTimeout(timer.current);
    };
  }, [isActiveIndex, setIsActiveIndex, slidesCount, inView, loop, isMobile, autoplay]);
  var handleManualSlideChange = function handleManualSlideChange(newIndex) {
    setIsActiveIndex(newIndex);
    swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideTo(newIndex);
    if (isMobile) {
      try {
        var _ref$current3, _ref$current3$childre;
        (_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : (_ref$current3$childre = _ref$current3.children[newIndex]) === null || _ref$current3$childre === void 0 ? void 0 : _ref$current3$childre.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      } catch (e) {
        console.error('Slider item not found');
      }
    }
  };
  return {
    isActiveIndex: isActiveIndex,
    handleManualSlideChange: handleManualSlideChange,
    ref: ref,
    setIsActiveIndex: setIsActiveIndex
  };
};